import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { contractCategoryConfig } from './contractCategoryConfig';
import { createContractCategoryValidationSchema } from './contractCategoryValidation';

// List/edit UI (including tracking “Created user” / “Updated user” display names) comes from contractCategoryConfig.

const { config: initializedConfig } = initializeModule(
  contractCategoryConfig,
  createContractCategoryValidationSchema
);

const ContractCategoryPage = createModulePage(initializedConfig, {
  displayName: 'ContractCategoryPage',
  description: 'Contract Category Management System - Contract classification management',
});

export default ContractCategoryPage;
